import React from 'react';
export const SidePanelContext = React.createContext({});
//# sourceMappingURL=SidePanelAPI.js.map